import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function AdministrarTratamientos() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item active">Administrador Contable</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Parámetros contables</h1>
                                        <p className="dash-subtitle mb-0">Precios, FEV y conceptos de pago</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/settings" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver a configuración
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-calculator"></i></span>
                                        Opciones
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/especialidades-referencia" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-tags"></i></div>
                                            <p className="quick-title">Clasificar Lista de Precios</p>
                                            <p className="quick-sub">Especialidades de Referencia</p>
                                        </Link>

                                        <Link to="/listas-precios" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-list-ol"></i></div>
                                            <p className="quick-title">Listas de Precios</p>
                                            <p className="quick-sub">Tarifas y Servicios</p>
                                        </Link>

                                        <Link to="/parametros-fev" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-invoice"></i></div>
                                            <p className="quick-title">Documentos Electrónicos</p>
                                            <p className="quick-sub">Configuración FEV</p>
                                        </Link>

                                        <Link to="/parametros-factura-no-electronica" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-alt"></i></div>
                                            <p className="quick-title">Factura No Electrónica</p>
                                            <p className="quick-sub">Parámetros de Impresión</p>
                                        </Link>

                                        <Link to="/parametros-egreso" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-money-bill-wave"></i></div>
                                            <p className="quick-title">Egresos</p>
                                            <p className="quick-sub">Consecutivo y prefijo</p>
                                        </Link>

                                        <Link to="/conceptos-pago" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-credit-card"></i></div>
                                            <p className="quick-title">Conceptos de Pago</p>
                                            <p className="quick-sub">Formas y Conceptos</p>
                                        </Link>

                                        <Link to="/conceptos-facturacion" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-tags"></i></div>
                                            <p className="quick-title">Conceptos de Facturación</p>
                                            <p className="quick-sub">Clasificación de facturas</p>
                                        </Link>

                                        <Link to="/convenios" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-handshake"></i></div>
                                            <p className="quick-title">Convenios</p>
                                            <p className="quick-sub">Catálogo informativo</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default AdministrarTratamientos;
